export default __webpack_public_path__ + "media/zurb/img/legacy/axe/axe-large-cc89ab866a49063013cf68f8b4780441.png";